export default __webpack_public_path__ + "static/media/Leila.c96c8bde.png";